import { format } from "date-fns"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import { SingleCheckbox } from "../../../ui/molecules/SingleCheckbox"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { Calendar } from "../../../ui/molecules/calendar"
import InputMultiSearch from "../../../ui/molecules/input/InputMultiSearch"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../ui/molecules/textArea"
import { OptionType } from "../../../utils"
import { GetAllOdc, resetGetAllOdcStatus } from "../../odc/slice"
import { CreateWaiverFromCodex, resetWaiverFromRequest, setFromAllowedEntryProtocolId, setFromBreakoutDate, setFromCompletePassing, setFromCustomerId, setFromDeniedEntryProtocolId, setFromFieldsPassing, setFromNote, setFromNotificationSubmissionProtocolId, setFromOdc, setFromSenderOrReceiver, setFromSubmissionNotificationOdcDate, setFromWaiverDepartureProtocol, WaiverFromCodexValidation } from "./liberatorieFromCodex/dataService/slice"
import { CreateWaiverToCodex, resetWaiverRequest, setAllowedDepartureProtocolId, setBreakoutDate, setCompletePassing, setCustomerId, setDeniedDepartureProtocolId, setEntryProtocol, setFieldsPassing, setNote, setNotificationChangeProtocolId, setOdc, setSenderOrReceiver, setSendingDossier, setSubmissionNotificationOdcDate, WaiverToCodexValidation } from "./liberatorieToCodex/dataService/slice"

interface Props {
    type: string
    close: () => void
}

export function AddLiberatoria(props: Props) {
    const [releaseCompleteAnotherOdc, setReleaseCompleteAnotherOdc] = useState(false)
    const [releaseLandsAnotherOdc, setReleaseLandsAnotherOdc] = useState(false)
    const [releaseFromCompleteAnotherOdc, setReleaseFromCompleteAnotherOdc] = useState(false)
    const [releaseFromLandsAnotherOdc, setReleaseFromLandsAnotherOdc] = useState(false)
    const [sendingDossier, setSendingDossierCheck] = useState(false)
    const [odc, setOdcOptions] = useState<OptionType[]>([])

    const waiverToState = useAppSelector(state => state.waiverToCodex)
    const waiverFromState = useAppSelector(state => state.waiverFromCodex)
    const odcState = useAppSelector(state => state.odc)
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(GetAllOdc({ itemsPerPage: 0, page: 0 }))
    }, [])

    useEffect(() => {
        if (odcState.getAllOdcStatus !== 'successfully' || !odcState.getAllOdcResponse) return
        dispatch(resetGetAllOdcStatus())
        setOdcOptions(odcState.getAllOdcResponse.data.map(o => ({ value: o.id, label: o.companyName } as OptionType)))
    }, [odcState.getAllOdcStatus])

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key !== 'Escape') return
            dispatch(resetWaiverRequest())
            dispatch(resetWaiverFromRequest())
            props.close()
        }
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [props])

    useEffect(() => {
        if (waiverToState.waiverToValidationStatus === 'successfully')
            dispatch(CreateWaiverToCodex(waiverToState.createUpdateWaiverToCodex))
    }, [waiverToState.waiverToValidationStatus])

    useEffect(() => {
        if (waiverFromState.waiverFromValidationStatus === 'successfully')
            dispatch(CreateWaiverFromCodex(waiverFromState.createUpdateWaiverFromCodex))
    }, [waiverFromState.waiverFromValidationStatus])

    const Footer = ({ onCancel, onSave }: { onCancel: () => void; onSave: () => void }) => (
        <div className="flex justify-end gap-2 pt-3">
            <ButtonComponent size="md" variant="outline" iconPosition="off" label="Annulla" color="gray" onClick={onCancel} />
            <ButtonComponent size="md" variant="solid" iconPosition="off" label="Salva" color="orange" onClick={onSave} />
        </div>
    )

    if (props.type === 'from') {
        return (
            <div className="px-6 py-4 flex flex-col gap-4">

                <ProtocolSearch
                    type="departure"
                    defaultValue={waiverFromState.createUpdateWaiverFromCodex.departureProtocolId}
                    onSelect={value => dispatch(setFromWaiverDepartureProtocol(value))}
                />

                <InputMultiSearch
                    searchOne
                    label="Cliente"
                    placeholder="Ragione sociale"
                    defaultClientIds={[waiverFromState.createUpdateWaiverFromCodex.customerId]}
                    onSelectAddHandler={res => dispatch(setFromCustomerId(res[0]))}
                />

                <div className="flex gap-4">
                    <div className="flex-1">
                        <MadfarmInput
                            label="Destinatario"
                            defaultValue={waiverFromState.createUpdateWaiverFromCodex.senderOrReceiver}
                            onChangeText={text => dispatch(setFromSenderOrReceiver(text))}
                        />
                    </div>
                    <div className="flex-1">
                        <Calendar
                            label="Data Invio"
                            selected={waiverFromState.createUpdateWaiverFromCodex.protocolDate}
                            disabled
                        />
                    </div>
                </div>

                <MadfarmStaticSelect
                    customZIndex={9999}
                    label="OdC"
                    noOptionsMessage=""
                    placeholder="ODC"
                    defaultValue={waiverFromState.createUpdateWaiverFromCodex.odcReferenceId}
                    options={odc}
                    onChange={value => {
                        // @ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setFromOdc(newValue))
                    }}
                />

                <SingleCheckbox
                    checked={releaseFromCompleteAnotherOdc}
                    setChecked={value => { setReleaseFromCompleteAnotherOdc(value); dispatch(setFromCompletePassing(value)) }}
                    label="Liberatoria per passaggio completo ad altro ODC"
                />

                <SingleCheckbox
                    checked={releaseFromLandsAnotherOdc}
                    setChecked={value => { setReleaseFromLandsAnotherOdc(value); dispatch(setFromFieldsPassing(value)) }}
                    label="Liberatoria per passaggio terreni ad altro ODC"
                />

                <Calendar
                    label="Data Presentazione Notifica"
                    selected={waiverFromState.createUpdateWaiverFromCodex.submissionNotificationDate}
                    onChange={date => dispatch(setFromSubmissionNotificationOdcDate(format(new Date(date), 'yyyy-MM-dd')))}
                />

                <ProtocolSearch
                    type="entry"
                    label="Protocollo entrata presentazione notifica"
                    defaultValue={waiverFromState.createUpdateWaiverFromCodex.notificationSubmissionProtocolId}
                    onSelect={value => dispatch(setFromNotificationSubmissionProtocolId(value))}
                />

                <ProtocolSearch
                    type="entry"
                    label="Comunicazione Liberatoria Negata"
                    defaultValue={waiverFromState.createUpdateWaiverFromCodex.deniedEntryProtocolId}
                    onSelect={value => dispatch(setFromDeniedEntryProtocolId(value))}
                />

                <ProtocolSearch
                    type="entry"
                    label="Comunicazione Liberatoria Concessa"
                    defaultValue={waiverFromState.createUpdateWaiverFromCodex.allowedEntryProtocolId}
                    onSelect={value => dispatch(setFromAllowedEntryProtocolId(value))}
                />

                <div className="flex gap-4">
                    <div className="flex-1">
                        <Calendar
                            label="Data Evasione"
                            selected={waiverFromState.createUpdateWaiverFromCodex.breakoutDate}
                            onClear={date => dispatch(setFromBreakoutDate(date))}
                            onChange={date => dispatch(setFromBreakoutDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>
                    <div className="flex-1">
                        <Calendar
                            label="Data Scadenza"
                            selected={waiverFromState.createUpdateWaiverFromCodex.expirationDate}
                            disabled
                        />
                    </div>
                </div>

                <TextArea
                    label="Note"
                    defaultValue={waiverFromState.createUpdateWaiverFromCodex.note}
                    onChangeText={text => dispatch(setFromNote(text))}
                />

                <Footer
                    onCancel={() => { dispatch(resetWaiverFromRequest()); props.close() }}
                    onSave={() => dispatch(WaiverFromCodexValidation(waiverFromState.createUpdateWaiverFromCodex))}
                />
            </div>
        )
    }

    if (props.type === 'to') {
        return (
            <div className="px-6 py-4 flex flex-col gap-4">

                <ProtocolSearch
                    type="entry"
                    defaultValue={waiverToState.createUpdateWaiverToCodex.entryProtocolId}
                    onSelect={value => dispatch(setEntryProtocol(value))}
                />

                <InputMultiSearch
                    searchOne
                    label="Ricerca Cliente"
                    placeholder="Ragione sociale"
                    defaultClientIds={[waiverToState.createUpdateWaiverToCodex.customerId]}
                    onSelectAddHandler={res => dispatch(setCustomerId(res[0]))}
                />

                <div className="flex gap-4">
                    <div className="flex-1">
                        <MadfarmInput
                            label="Mittente"
                            defaultValue={waiverToState.createUpdateWaiverToCodex.senderOrReceiver}
                            onChangeText={text => dispatch(setSenderOrReceiver(text))}
                        />
                    </div>
                    <div className="flex-1">
                        <Calendar
                            label="Data Ricezione"
                            selected={waiverToState.createUpdateWaiverToCodex.protocolDate}
                        />
                    </div>
                </div>

                <MadfarmStaticSelect
                    customZIndex={9999}
                    label="OdC"
                    noOptionsMessage=""
                    placeholder="ODC"
                    error={waiverToState.waiverToErrors.odcReference}
                    errorLabel="OdC mancante"
                    defaultValue={waiverToState.createUpdateWaiverToCodex.odcReferenceId}
                    options={odc}
                    onChange={value => {
                        // @ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setOdc(newValue))
                    }}
                />

                <SingleCheckbox
                    checked={releaseCompleteAnotherOdc}
                    setChecked={value => { setReleaseCompleteAnotherOdc(value); dispatch(setCompletePassing(value)) }}
                    label="Liberatoria per passaggio completo ad altro ODC"
                />

                <SingleCheckbox
                    checked={releaseLandsAnotherOdc}
                    setChecked={value => { setReleaseLandsAnotherOdc(value); dispatch(setFieldsPassing(value)) }}
                    label="Liberatoria per passaggio terreni ad altro ODC"
                />

                <ProtocolSearch
                    type="entry"
                    label="Notifica di variazione per cambio OdC"
                    defaultValue={waiverToState.createUpdateWaiverToCodex.deniedDepartureProtocolId}
                    onSelect={value => dispatch(setNotificationChangeProtocolId(value))}
                />

                <Calendar
                    label="Data Presentazione Notifica"
                    selected={waiverToState.createUpdateWaiverToCodex.submissionNotificationOdcDate}
                    onChange={date => dispatch(setSubmissionNotificationOdcDate(format(new Date(date), 'yyyy-MM-dd')))}
                />

                <ProtocolSearch
                    type="departure"
                    label="Comunicazione Liberatoria Negata"
                    defaultValue={waiverToState.createUpdateWaiverToCodex.allowedDepartureProtocolId}
                    onSelect={value => dispatch(setAllowedDepartureProtocolId(value))}
                />

                <ProtocolSearch
                    type="departure"
                    label="Comunicazione Liberatoria Concessa"
                    defaultValue={waiverToState.createUpdateWaiverToCodex.deniedDepartureProtocolId}
                    onSelect={value => dispatch(setDeniedDepartureProtocolId(value))}
                />

                <div className="flex gap-4">
                    <div className="flex-1">
                        <Calendar
                            label="Data Evasione"
                            selected={waiverToState.createUpdateWaiverToCodex.breakoutDate}
                            onClear={date => dispatch(setBreakoutDate(date))}
                            onChange={date => dispatch(setBreakoutDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>
                    <div className="flex-1">
                        <Calendar
                            label="Data Scadenza"
                            selected={waiverToState.createUpdateWaiverToCodex.expirationDate}
                            disabled
                        />
                    </div>
                </div>

                <SingleCheckbox
                    checked={sendingDossier}
                    setChecked={value => { setSendingDossierCheck(value); dispatch(setSendingDossier(value)) }}
                    label="Invio fascicolo senza richiesta dell'OdC (articolo, 14 comma 1, lettera e) del Decreto Legislativo n.148 del 06/10/2023"
                />

                <TextArea
                    label="Note"
                    defaultValue={waiverToState.createUpdateWaiverToCodex.note}
                    onChangeText={text => dispatch(setNote(text))}
                />

                <Footer
                    onCancel={() => { dispatch(resetWaiverRequest()); props.close() }}
                    onSave={() => dispatch(WaiverToCodexValidation(waiverToState.createUpdateWaiverToCodex))}
                />
            </div>
        )
    }

    return <div />
}